import React, { Component } from 'react';
import {connect} from "react-redux";
import {IRootState} from "../../store";
import DispatchProps from "../../utils/DispatchProps";
import { AccountInfo } from '@azure/msal-browser';
import SignInPage from "./SignInPage";
import HomeRedirect from "./HomeRedirect";

interface WelcomePageProps {
    user?: AccountInfo;
}

class WelcomePage extends Component<WelcomePageProps & DispatchProps ,any> {
    static displayName = WelcomePage.name;
    
    constructor(props: WelcomePageProps & DispatchProps) {
        super(props);
        
        this.state = {
            
        }
    }
    
    async componentDidMount() {
    }
    
    render () {
        
        if(this.props.user)
        {
            return <HomeRedirect/>
        }
        return (
            <SignInPage prompt={"To get started, sign in with your Microsoft Account"} thenRedirectTo={"/"}/>
        );
    }
}

export default connect(
    (state: IRootState): WelcomePageProps => {
        return {
            user: state.auth.user,
        };
    }
)(WelcomePage)